import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "Clinician__Map",
  class: "dashboard-card"
}
const _hoisted_2 = {
  key: 0,
  class: "p-0 w-100 h-100",
  id: "Tasks__Map"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 justify-content-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }),
  /*#__PURE__*/_createElementVNode("b", { class: "mx-2" }, "Waiting for your location"),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" })
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "d-flex flex-column align-items-center px-3 mt-4 text-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-size-md mb-2" }, " Provide your location to view how far your visits are from your location. ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createCommentVNode(" CONTENT "),
    (!_ctx.zipNotEntered)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4, 512 /* NEED_PATCH */)), [
          [_vShow, !_ctx.zipNotEntered]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("button", {
            class: "btn btn-xs btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enterLocation()))
          }, "ENTER LOCATION")
        ]))
  ]))
}